// extracted by mini-css-extract-plugin
module.exports = {"Content":"AugmentedViewer_Content__12Cg1","CameraContainer":"AugmentedViewer_CameraContainer__2zJ3C","Back":"AugmentedViewer_Back__3YfXj"};